<template>
  <b-modal
    v-model="showModal"
    title="Pemetaan Level & Taksonomi Bloom"
    title-class="text-black font-18"
    body-class="p-4"
    size="xl"
    hide-footer
  >
    <!-- Loading -->
    <div v-if="isFetching" class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <p class="mt-2 text-muted">Memuat data...</p>
    </div>

    <!-- Table -->
    <div v-else class="table-responsive">
      <table class="table table-bordered table-condensed align-middle">
        <thead class="table-light text-center align-middle">
          <tr>
            <th style="width: 60px">Level Profil</th>
            <th>Deskripsi Perilaku</th>
            <th style="width: 180px">Level Kognitif Taksonomi Bloom</th>
            <th>Deskripsi</th>
            <th>Indikator yang Diukur</th>
            <th style="width: 60px">Jumlah</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in data" :key="item.idlevel_kompetensi">
            <!-- Jika tidak ada taksonomi -->
            <tr v-if="!item.taksonomi || item.taksonomi.length === 0">
              <td>{{ item.nama_level }}</td>
              <td class="text-start">{{ item.deskripsi_perilaku }}</td>
              <td colspan="3" class="text-muted fst-italic text-center">
                Belum ada taksonomi
              </td>
              <td class="text-center">{{ item.taksonomi_count }}</td>
            </tr>

            <!-- Row pertama: rowspan untuk nama_level & deskripsi_perilaku -->
            <template v-else>
              <tr
                v-for="(taksonomi, tIndex) in item.taksonomi"
                :key="taksonomi.idverif_taksonomi"
              >
                <td v-if="tIndex === 0" :rowspan="item.taksonomi.length">
                  {{ item.nama_level }}
                </td>
                <td
                  v-if="tIndex === 0"
                  :rowspan="item.taksonomi.length"
                  class="text-start"
                >
                  {{ item.deskripsi_perilaku }}
                </td>
                <td>{{ taksonomi.level_kognitif }}</td>
                <td class="text-start">{{ taksonomi.deskripsi }}</td>
                <td class="text-start">{{ taksonomi.indikator }}</td>
                <td v-if="tIndex === 0" :rowspan="item.taksonomi.length" class="text-center">
                  {{ item.taksonomi_count }}
                </td>
              </tr>
            </template>
          </template>

          <!-- Empty state -->
          <tr v-if="!isFetching && data.length === 0">
            <td colspan="6" class="text-center text-muted py-4">
              Tidak ada data
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer -->
    <div class="text-end mt-3">
      <button type="button" class="btn btn-light" @click="$emit('close')">
        Tutup
      </button>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "ModalPemetaanLevelTaksonomi",

  emits: ["close"],

  data() {
    return {
      showModal: false,
      isFetching: false,
      data: [],
    };
  },

  methods: {
    // Dipanggil dari parent via $refs
    open() {
      this.showModal = true;
      this.fetchData();
    },

    async fetchData() {
      this.isFetching = true;
      this.data = [];
      try {
        const url =
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/level-kompetensi/pemetaan-taksonomi";

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${localStorage.access_token}` },
        });

        this.data = response.data.data ?? [];
      } catch (error) {
        console.error("Gagal memuat data:", error);
        Swal.fire({
          icon: "error",
          title: "Gagal memuat data",
          text: error.response?.data?.data ?? "Terjadi kesalahan",
        });
      } finally {
        this.isFetching = false;
      }
    },
  },
};
</script>
